
export const LogoutSystem = ()=> {
    localStorage.removeItem(process.env.REACT_APP_TOKEN!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_ROUTER!);
    localStorage.removeItem(process.env.REACT_APP_TOKEN_ROUTER_BACKUP!);
    window.location.replace('');
}